import React, { useState, useEffect } from "react";
import TMHBanner from "../../components/TMHBanner/TMHBanner";
import TMHFormWrapper from "../../components/TMHForm/TMHFormWrapper";
import TMHFormBase from "../../components/TMHForm/TMHFormBase";
import TMHFormInput from "../../components/TMHForm/TMHFormInput";
import TMHLoader from "../../components/TMHLoader/TMHLoader";
import "./ResetPasswordPage.css";
import config from "../../config.json"
import TMHFooter from "../../components/TMHFooter/TMHFooter";
import { useParams, useNavigate } from 'react-router-dom';
import { useTitle } from 'react-use'
import ReactGA from "react-ga4"

export default function ResetPasswordPage() {
    useTitle("Reset Password - The Movie House TV")
    useEffect(() => {
        ReactGA.send("pageview")
    })

    const { email, ts, hash } = useParams();
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false)
    const [errorText, setErrorText] = useState("")
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [successText, setSuccessText] = useState("Please reset your password for your account " + email)

    const IsInvalid = password !== confirmPassword || password === "";

    
    function checkConfirmPassword(confirmPassword){
        setConfirmPassword(confirmPassword)
        if (password !== confirmPassword && password !== ""){
            setErrorText("Passwords do not match.")
            setSuccessText("")
        }else{
            setErrorText("")
            setSuccessText("Please reset your password for your account " + email)
        }
    }

    async function handleSubmit(event) {
        event.preventDefault();
        setIsLoading(true)

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Cache-Control", "no-cache");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({
                "email": email,
                "password": password,
                "confirm_password": confirmPassword,
                "ts": parseInt(ts),
                "hash": hash
            }),
        };

        setErrorText("")
        setSuccessText("")
        fetch(config.baseUrl + "update_password", requestOptions)
            .then((response) => {
            return new Promise((resolve) => response.json()
                .then((json) => resolve({
                status: response.status,
                ok: response.ok,
                json
                })))
            }).then(
                (result) => {
                    if (result.ok) {
                        setSuccessText(result.json.message)
                        setIsLoading(false)
                        navigate("/login/Reset successful");
                    }
                    else {
                        setErrorText(result.json.message)
                        setIsLoading(false)
                    }
                },
                (error) => {
                    console.log(error)
                    setErrorText(error.toString())
                    setSuccessText("")
                    setIsLoading(false)
                }
            )
    }

    return (
        <TMHBanner classOption="only-gradient" isLogged={false}>
            <TMHFormWrapper classOption="reset-password-page-wrapper">
                <TMHFormBase onSubmit={handleSubmit} method="POST">
                    <div className="reset-password-text">Reset Password</div>
                    <div className="reset-password-page-warning-text">
                        <div className="error-text">{errorText}</div>
                        <div className="success-text">{successText}</div>
                    </div>
                    <TMHFormInput
                        type="password"
                        placeholder="New password"
                        autoComplete="off"
                        value={password}
                        onChange={({ target }) => setPassword(target.value)}
                    />
                    <TMHFormInput
                        type="password"
                        placeholder="Re enter password"
                        autoComplete="off"
                        value={confirmPassword}
                        onChange={({ target }) => checkConfirmPassword(target.value)}
                    />
                    <button type="submit" className="reset-password-button" disabled={IsInvalid}>
                        <div className="reset-password-reset-text">Reset password</div>
                    </button>
                </TMHFormBase>
                {isLoading && <TMHLoader />}
            </TMHFormWrapper>
            <TMHFooter />
        </TMHBanner>
    )
}
